import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Books from './components/Books';
import Munfaridat from './components/Munfaridat';
import Videos from './components/Videos';
import Events from './components/Events';
import Contact from './components/Contact';
import AdminPanel from './components/AdminPanel';

import './styles/global.css';

/* ── Public Website ──────────────────────────────────── */
function Website() {
  const [darkMode, setDarkMode] = useState(true);

  return (
    <div className="app" data-theme={darkMode ? 'dark' : 'light'}>
      <Navbar darkMode={darkMode} setDarkMode={(val) => {
        setDarkMode(val);
        document.documentElement.setAttribute('data-theme', val ? 'dark' : 'light');
      }} />

      <main>
        <Hero />
        <About />
        <Books />
        <Munfaridat />
        <Videos />
        <Events />
        <Contact />
      </main>
    </div>
  );
}

/* ── App Router ──────────────────────────────────────── */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Website />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}